import MainMeterForm from './MainMeterForm';

const UpdateMainMeter = () => {
    return <MainMeterForm isUpdate={true} />;
};

export default UpdateMainMeter;
